// extracted by mini-css-extract-plugin
module.exports = {"container":"LinkGroup_container__3ytMH","groupTitle":"LinkGroup_groupTitle__2fBzB","link":"LinkGroup_link__2yYVR","disabled":"LinkGroup_disabled__3ZsWk"};